import React, { useCallback } from 'react';
import { useSnackbar } from 'notistack';
import * as Sentry from '@sentry/react';

import { ENABLE_SENTRY } from '../../../_configuration';
import { IntlMsg } from '../../components/_core/IntlMsg/intl-msg.component';
import { messages } from '../../components/_core/OfflineHandler/offline-handler.messages';
import { ScoreNotBufferedError } from '../utils/user-session.service';
import { useSnackbarDismissAction } from './use-snackbar-dismiss-action';

// Tells the scorer a score never reached device storage. Unlike a refusal the server recorded,
// nothing holds this score anywhere, so it is the one save failure the user must act on at once.
export const useScoreBufferFailureSnackbar = () => {
  const { enqueueSnackbar } = useSnackbar();
  const dismissAction = useSnackbarDismissAction();

  return useCallback((err: unknown) => {
    if (ENABLE_SENTRY) Sentry.captureException(err);
    const signedOut = err instanceof ScoreNotBufferedError && err.reason === 'no-user';
    // Persists rather than auto-hiding: this is the only save failure with no copy of the
    // score anywhere, so it must survive the scorer looking away from the tablet.
    enqueueSnackbar(<IntlMsg {...(signedOut ? messages.scoreNotBufferedSignedOut : messages.scoreNotBuffered)} />,
      { variant: 'error', persist: true, action: dismissAction });
  }, [enqueueSnackbar, dismissAction]);
};
